<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Job Position</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="jobPosition.uid === null">New</span>
              <span v-else>
                {{ jobPosition.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">ID</label>
              <div class="col-sm-9">
                <input type="text" v-model="jobPosition.id" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="jobPosition.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="grade_id" class="col-sm-3 col-form-label text-left">Department</label>
              <div class="col-sm-9">
                <select v-model="jobPosition.department_id" class="form-control">
                  <option v-for="d in departmentList" :key="d.id" :value="d.id">
                    [{{ d.id }}] {{ d.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updateJobPosition" class="btn btn-sm btn-primary pull-right" v-show="jobPosition.uid !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createJobPosition" class="btn btn-sm btn-primary pull-right" v-show="jobPosition.uid == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <!-- <pre>
      {{ jobPosition }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, employeeUrl } from '../../config'

export default {
  name: 'JobPositionForm',
  props: ['jobPosition'],
  computed: {
    ...mapState({
      departmentList: state => state.employees.departmentList
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateJobPosition () {
      axios.put(employeeUrl + '/position/' + this.jobPosition.uid, this.jobPosition, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Job Position', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createJobPosition () {
      axios.post(employeeUrl + '/position', this.jobPosition, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
